import React from "react";

const AceInhibitorsNote = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[259px] ">
      <p className="text-gray-800 text-sm  font-normal">
      Also helps protect the kidneys, treat heart failure, and improve recovery after a heart attack.
      </p>
    </div>
  );
};

export default AceInhibitorsNote;
